<template>
  <div id="app" class="card-overlay">
    <template v-if="!$route.meta.allowAnonymous">
      <v-app>
        <v-main>
          <router-view />
        </v-main>
      </v-app>
    </template>
    <template v-else>
      <v-app id="inspire" class="card-overlay">
        <navigation :toggle="drawer"/>
        <toolbar @toggleNavigationBar="drawer = !drawer" :name="$route.meta.name"/>
        <v-main>
          <router-view/>
        </v-main>
        <v-footer color="blue darken-2" app>
          <span class="white--text"> {{name}} &copy; {{ year() }}</span>
          <v-spacer></v-spacer>
          <span class="white--text"> Version {{ version }}</span>
        </v-footer>
      </v-app>
    </template>
  </div>

</template>

<script>
export default {
  name: 'App',
  data: () => ({
    drawer: false,
    name: process.env.VUE_APP_COMPANY_NAME,
    version: process.env.VUE_APP_VERSION
  }),
  methods: {
    year () {
      const year = new Date().toISOString().substr(0, 4)
      return year
    }
  }
}
// iisexpress-proxy 3000 to 3024
</script>
